import toast from "react-hot-toast";

const REQUIRED_MESSAGE = " Is Required";
const MIN_LENGTH_MESSAGE = " length must be at least ";
const MAX_LENGTH_MESSAGE = " length must be up to ";
const NUMBER_MESSAGE = " must be a number";
const MIN_NUMBER_MESSAGE = " must be a number bigger than ";
const MAX_NUMBER_MESSAGE = " must be a number smaller or equal to ";
const WHOLE_NUMBER_MESSAGE = " must be a whole number";
const POSITIVE_NUMBER_MESSAGE = " must be a positive amount number";
const FULL_NAME_MESSAGE = "Please enter full name";
const CREDIT_CARD_CUSTOM_MESSAGE = "Please enter a valid credit card number";
const CREDIT_CARD_SUPPORTED_MESSAGE = "We do not accept American Express";
const CREDIT_CARD_EXPIRE_MESSAGE = "Please enter a valid expiration date (MMYY)";
const ICCID_MESSAGE = "Please enter a valid ICCID: 19 or 20 digits number starts with 89.";
const ESN_MEID_IMEI_MESSAGE =
  "Format is not valid.\nESN should be 11 decimal digits \nor 8 hexadecimal digits.\nMEID should be 18 decimal digits\nor 14 hexadecimal digits.";
const ZIP_MESSAGE = "Zip Code should be 5 digits or 10 with a dash as the 6th";
const EMAIL_DOMAIN_MESSAGE = "Email domain list not valid";
const EMAIL_MESSAGE = "Email list not valid";
const PASSWORD_VALID_MESSAGE =
  "Your password must be at least 8 characters including a lowercase letter, an uppercase letter, a number and a special character (@$!%*?&^#+-)";
const ONLY_DIGITS_MESSAGE = "Please enter only digits";
const DECIMAL_PLACES_MESSAGE = " is limited to [decimal_places] decimal places";

export const validate = (rules) => {
  for (const rule in rules) {
    const ruleValues = rules[rule];
    const { object, messageName } = ruleValues;

    if (ruleValues.skip) continue;
    if (ruleValues.required) {
      if (object === undefined || object === null || object === "") {
        toast.error(messageName + REQUIRED_MESSAGE);
        return false;
      }
    }
    if (ruleValues.minLength) {
      if (object.toString().length < ruleValues.minLength) {
        toast.error(messageName + MIN_LENGTH_MESSAGE + ruleValues.minLength + " characters");
        return false;
      }
    }
    if (ruleValues.maxLength) {
      if (object.toString().length > ruleValues.maxLength) {
        toast.error(messageName + MAX_LENGTH_MESSAGE + ruleValues.maxLength + " characters");
        return false;
      }
    }
    if (ruleValues.number) {
      if (isNaN(object)) {
        toast.error(messageName + NUMBER_MESSAGE);
        return false;
      }
    }
    if (ruleValues.minNumber !== undefined) {
      if (isNaN(object) || object < ruleValues.minNumber) {
        toast.error(messageName + MIN_NUMBER_MESSAGE + ruleValues.minNumber);
        return false;
      }
    }
    if (ruleValues.maxNumber !== undefined) {
      if (isNaN(object) || object > ruleValues.maxNumber) {
        toast.error(messageName + MAX_NUMBER_MESSAGE + ruleValues.maxNumber);
        return false;
      }
    }
    if (ruleValues.positiveNumber) {
      if (object <= 0) {
        toast.error(messageName + POSITIVE_NUMBER_MESSAGE);
        return false;
      }
    }
    if (ruleValues.wholeNumber) {
      if (object % 1 !== 0) {
        toast.error(messageName + WHOLE_NUMBER_MESSAGE);
        return false;
      }
    }
    if (ruleValues.fullName) {
      if (object.match(/.\s./) === null) {
        toast.error(FULL_NAME_MESSAGE);
        return false;
      }
    }
    if (ruleValues.ICCID) {
      if (object.match(/^(89[0-9]{17,18})$/i) === null || object === "") {
        toast.error(ICCID_MESSAGE);
        return false;
      }
    }
    if (ruleValues.digits) {
      if (object.match(/^[0-9]*$/) === null) {
        toast.error(messageName + ": " + ONLY_DIGITS_MESSAGE);
        return false;
      }
    }
    if (ruleValues.creditCardCustom) {
      if (object == null || object.length < 9) {
        toast.error(CREDIT_CARD_CUSTOM_MESSAGE);
        return false;
      }
      if (!isTestCreditCard(object)) {
        const cc_result = validate_number(object);
        if (!(cc_result.length_valid && cc_result.luhn_valid)) {
          toast.error(CREDIT_CARD_CUSTOM_MESSAGE);
          return false;
        }
      }
    }
    if (ruleValues.creditcardSupported) {
      // At this moment this limitation does not exist (used to be for American Express)
      if (object == null) {
        toast.error(CREDIT_CARD_SUPPORTED_MESSAGE);
        return false;
      }
    }
    if (ruleValues.creditCardExpire) {
      const value = object;
      if (value == null || value.length !== 4 || value < "0113" || value > "1299") {
        toast.error(CREDIT_CARD_EXPIRE_MESSAGE);
        return false;
      }
      let dateVal = new Date(2000 + parseInt(value.substring(2)), value.substring(0, 2), 1);
      if (new Date() > dateVal) {
        toast.error(CREDIT_CARD_EXPIRE_MESSAGE);
        return false;
      }
    }
    if (ruleValues.ESN_MEID_IMEI) {
      if (object.match(/^([A-F0-9]{8}|[0-9]{11}|[A-F0-9]{14}|[0-9]{18}|([0-9]{15}))$/i) === null || object === "") {
        toast.error(ESN_MEID_IMEI_MESSAGE);
        return false;
      }
    }
    if (ruleValues.zip) {
      if (object.match(/(^\d{5}$)|(^\d{5}-\d{4}$)/) === null && object !== "") {
        toast.error(ZIP_MESSAGE);
        return false;
      }
    }
    if (ruleValues.emailDomain) {
      if (object !== null) {
        let domains = object.split(",");
        for (let i = 0; i < domains.length; i++) {
          if (
            domains[i].trim() &&
            domains[i].trim().match(/^@([A-Za-z0-9-]+)(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/) == null
          ) {
            toast.error(EMAIL_DOMAIN_MESSAGE);
            return false;
          }
        }
      }
    }
    if (ruleValues.email) {
      if (object !== "" && !emailValidation(object)) {
        toast.error(EMAIL_MESSAGE);
        return false;
      }
    }
    if (ruleValues.password) {
      if (object.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&^#+-])[A-Za-z\d@$!%*?&^#+-]{8,}$/) === null) {
        toast.error(PASSWORD_VALID_MESSAGE);
        return false;
      }
    }
    if (ruleValues.decimalPlaces) {
      if (object !== null && countDecimals(object) > ruleValues.decimalPlaces) {
        toast.error(messageName + DECIMAL_PLACES_MESSAGE.replace("[decimal_places]", ruleValues.decimalPlaces));
        return false;
      }
    }
  }

  return true;
};

const testCC = [
  "4457010000000009",
  "5112010000000003",
  "6011010000000003",
  "4457010100000008",
  "4457002100000005",
  "4457002700000009",
  "4457002300000003",
  "4457002900000007",
  "4457002500000001",
  "4457002000000006",
  "4457002200000004",
  "4457000600000004",
  "5112010000000003",
  "5112002200000008",
  "5112001900000003",
  "5112001600000006",
  "5112001800000004",
  "6011010000000003",
  "6011010100000002",
  "375001010000003",
  "375001000000005",
];

const isTestCreditCard = (value) => {
  if (value == null) return false;
  if (testCC.includes(value)) return true;
};

const card_types = [
  {
    name: "AMERICAN_EXPRESS",
    pattern: /^3[47]/,
    valid_length: [15],
  },
  {
    name: "diners club carte blanche",
    pattern: /^30[0-5]/,
    valid_length: [14],
  },
  {
    name: "diners club international",
    pattern: /^36/,
    valid_length: [14],
  },
  {
    name: "jcb",
    pattern: /^35(2[89]|[3-8][0-9])/,
    valid_length: [16],
  },
  {
    name: "laser",
    pattern: /^(6304|670[69]|6771)/,
    valid_length: [16, 17, 18, 19],
  },
  {
    name: "VISA",
    pattern: /^(4026|417500|4508|4844|491(3|7))/,
    valid_length: [16],
  },
  {
    name: "VISA",
    pattern: /^4/,
    valid_length: [16],
  },
  {
    name: "MASTERCARD",
    pattern: /^5[1-5]/,
    valid_length: [16],
  },
  {
    name: "maestro",
    pattern: /^(5018|5020|5038|6304|6759|676[1-3])/,
    valid_length: [12, 13, 14, 15, 16, 17, 18, 19],
  },
  {
    name: "DISCOVER",
    pattern: /^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)/,
    valid_length: [16],
  },
];

const get_card_type = (number, card_types) => {
  var card_type, _i, _len;
  for (_i = 0, _len = card_types.length; _i < _len; _i++) {
    card_type = card_types[_i];
    if (number.match(card_type.pattern)) {
      return card_type;
    }
  }
  return null;
};

const is_valid_luhn = (number) => {
  var digit, n, sum, _i, _len, _ref;
  sum = 0;
  _ref = number.split("").reverse();
  for (n = _i = 0, _len = _ref.length; _i < _len; n = ++_i) {
    digit = _ref[n];
    digit = +digit;
    if (n % 2) {
      digit *= 2;
      if (digit < 10) {
        sum += digit;
      } else {
        sum += digit - 9;
      }
    } else {
      sum += digit;
    }
  }
  return sum % 10 === 0;
};

const __indexOf =
  [].indexOf ||
  function (item) {
    for (var i = 0, l = this.length; i < l; i++) {
      if (i in this && this[i] === item) return i;
    }
    return -1;
  };

const is_valid_length = (number, card_type) => {
  var _ref;
  return ((_ref = number.length), __indexOf.call(card_type.valid_length, _ref) >= 0);
};

const normalize = (number) => {
  return number.replace(/[ -]/g, "");
};

const validate_number = (number) => {
  number = normalize(number);
  let card_type, length_valid, luhn_valid;
  card_type = get_card_type(number, card_types);
  luhn_valid = false;
  length_valid = false;
  if (card_type != null) {
    luhn_valid = is_valid_luhn(number);
    length_valid = is_valid_length(number, card_type);
  }
  return {
    card_type: card_type,
    luhn_valid: luhn_valid,
    length_valid: length_valid,
  };
};

export const emailValidation = (email) => {
  let emails;

  if (email.includes(";")) emails = email.split(";");
  else emails = email.split(",");

  emails = emails.map((e) => e.trim());

  for (let i = 0; i < emails.length; i++) {
    if (!checkEmail(emails[i])) return false;
  }
  return true;
};

export const checkEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(/^(?=.{1,64}@)[A-Za-z0-9_-]+(\.[A-Za-z0-9_-]+)*@[^-][A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*(\.[A-Za-z]{2,})$/);
};

const countDecimals = (value) => {
  if (Math.floor(value) === value) return 0;
  return value.toString().includes(".") ? value.toString().split(".")[1].length : 0;
};
